import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ModelPortfoliosComponent } from 'src/app/pages/model-portfolios/model-portfolios.component';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';

const routes: Routes = [
  {
    path: '',
    component: ModelPortfoliosComponent,
    canActivate: [AuthenticationService],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ModelPortfoliosRoutingModule { }
